import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CpLoaderService {
  loaderCount = 0;

  constructor() { }
  isLoading = new Subject<boolean>();

  show(url) {
    // TODO: Below console log is used to know what api calls are being done. This should ideally be configurable.
    // Need to make changes to set the configurability.
    console.log('show', url);
    this.loaderCount += 1;
    this.isLoading.next(true);
  }

  hide(url) {
    this.loaderCount -= 1;
    if (this.loaderCount === 0) {
      this.isLoading.next(false);
    }
  }
}
